<template>
  <div class="portlet-body form">
    <form class="form-horizontal" role="form">
      <div class="form-body">
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label class="col-md-4 control-label">
                {{ 'production_reports.production_list.production_date' | trans }}:
              </label>
              <div class="col-md-8">
                <date-picker v-model="formDate" :time="false" :is-nullable="false"/>
              </div>
            </div>
          </div>
          <div class="col-md-6 pl-0">
            <button
                type="button"
                :disabled="!checkedRows.length || disabled"
                class="btn btn-primary"
                @click="assignDateToChecked">
              {{ 'assign_team.assign_date_btn' | trans }}
            </button>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label class="col-md-4 control-label">{{ 'assign_team.production_team_select' | trans }}:</label>
              <div class="col-md-8">
                <single-select
                    :checked="formTeam"
                    :options="teams"
                    @input="formTeam = $event"
                />
              </div>
            </div>
          </div>
          <div class="col-md-6 pl-0">
            <button
                type="button"
                class="btn btn-primary"
                :disabled="!formTeam || !checkedRows.length || disabled"
                @click="assignTeamToChecked">
              {{ 'assign_team.assign_team_btn' | trans }}
            </button>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label class="col-md-4 control-label">{{ 'assign_team.unfolding_team_select' | trans }}:</label>
              <div class="col-md-8">
                <single-select
                    :checked="formUnfoldingTeam"
                    :options="unfoldingTeams"
                    @input="formUnfoldingTeam = $event"
                />
              </div>
            </div>
          </div>
          <div class="col-md-6 pl-0">
            <button
                type="button"
                class="btn btn-primary"
                :disabled="!formUnfoldingTeam || !checkedRows.length || disabled"
                @click="assignUnfoldingTeamToChecked">
              {{ 'assign_team.assign_team_btn' | trans }}
            </button>
          </div>
        </div>
      </div>
    </form>
    <div class="row">
      <div class="col-md-7">
        <div>
          <label class="mt-checkbox mt-checkbox-outline">
            <p class="checkbox-text">Zaznacz wszystkie</p>
            <input
                v-model="isCheckedAll"
                type="checkbox"
                @click="checkAll"
            />
            <span></span>
          </label>
        </div>
      </div>

      <view-loader :loading="disabled" size="100px" show-content>
        <assign-team-meal-row
            v-for="(mealRow, index) in mealRows"
            ref="assignTeamMealRow"
            :key="index"
            :meal="mealRow"
            :is-checked="checkedRows.includes(mealRow.mealId)"
            :teams="teams"
            :unfolding-teams="unfoldingTeams"
            :hours="hours"
            :disabled="disabled"
            :show-details="Boolean(true)"
            @check="checkMeal"
            @assingteam="assignTeamByMeal"
        />
      </view-loader>
    </div>
  </div>
</template>

<script>
import AssignTeamMealRow from '@js/forms/assignTeam/MealRow.vue'
import DateHelper from '@js/helpers/dateHelper'
import DatePicker from '@component/datePicker.vue'
import SingleSelect from '@component/singleselect.vue'
import ViewLoader from '@component/ViewLoader.vue'
import axios from 'axios'
import mixins from '@js/mixins.js'
import toastr from '@js/toastr'

export default {
  name: 'AssignTeamMeals',
  components: {
    ViewLoader,
    AssignTeamMealRow,
    DatePicker,
    SingleSelect,
  },
  mixins: [mixins],
  props: {
    meals: {
      type: Array,
      required: true,
    },
    date: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      required: true,
    }
  },
  data() {
    return {
      formTeam: null,
      formUnfoldingTeam: null,
      formDate: DateHelper.format(DateHelper.subtract(1, this.date)),
      teams: [],
      unfoldingTeams: [],
      checkedRows: [],
      assignedMeals: null,
      isCheckedAll: false,
      requestTeamDone: false,
      requestAssignTeamDone: false,
      requestUnfoldingTeamDone: false,
    }
  },
  computed: {
    mealRows() {
      if (this.requestTeamDone && this.requestAssignTeamDone && this.requestUnfoldingTeamDone) {
        const rows = this.meals.reduce((acc, meal) => {
          if (meal.depth === 1) {
            acc.push(this.getMergedMeal(meal))
          }
          return acc
        }, [])

        rows.sort((a, b) => a.mealName.localeCompare(b.mealName))
        return rows
      }
      return []
    },
    checkedMeals() {
      return this.meals.filter(meal => this.checkedRows.includes(meal.mealId))
    },
    hours() {
      let hours = []
      let _hours = [...Array(24).keys()]
      _hours.forEach((hour) => {
        let hourText = hour
        if (hourText.toString().length < 2) {
          hourText = `0${hour.toString()}`
        }
        hours.push({ 'id': hour,
          'name': `${hourText}:00` })
      })
      return hours
    }
  },
  mounted() {
    this.getTeams()
    this.getUnfoldingTeams()
    this.getAssignedMeals(true)
  },
  methods: {
    getMealComponents(parentUid, depth) {
      let that = this
      let components = []
      this.meals.forEach(meal => {
        if (meal.uid.startsWith(parentUid) && meal.depth === depth) {
          components.push(that.getMergedMeal(meal))
        }
      })
      return components
    },
    getMergedMeal(meal) {
      const mealRow = {}
      const assignedMeal = this.assignedMeals.has(meal.uid) ? this.assignedMeals.get(meal.uid) : null

      Object.assign(mealRow, meal)
      Object.assign(mealRow, {
        kind: window.Translator.trans(`assign_team.types.${meal.kind}`),
        unitName: meal.unit === 'mass'
          ? window.Translator.trans('material.entity.units.kg') : window.Translator.trans('material.entity.units.piece'),
        brands: this.arrayToString(this.getUniqueValues(meal.brands)),
        sizes: this.arrayToString(this.getUniqueValues(meal.sizes)),
        quantity: this.dcNumberFormat(meal.quantity),
        teamId: assignedMeal && assignedMeal.teamId ? assignedMeal.teamId : null,
        unfoldingTeamId: assignedMeal && assignedMeal.unfoldingTeamId ? assignedMeal.unfoldingTeamId : null,
        productionDate: assignedMeal && assignedMeal.productionDate ? new Date(assignedMeal.productionDate) : null,
        hour: assignedMeal && assignedMeal.hour !== null ? assignedMeal.hour : null,
        isGenerated: assignedMeal ? assignedMeal.isGenerated : false,
        components: this.getMealComponents(`${mealRow.uid.replace('f_', 'c_')}_`, meal.depth + 1),
      })

      return mealRow
    },
    checkMeal(mealId) {
      const checkedIndex = this.checkedRows.indexOf(mealId)
      if (checkedIndex >= 0) {
        this.checkedRows.splice(checkedIndex, 1)
      } else if (checkedIndex < 0) {
        this.checkedRows.push(mealId)
      }
    },
    assignTeamByMeal(args) {
      axios.post(
        Routing.generate('api_post_assign_team_new',
          {
            id: args.teamId || 0,
            '_type': args.type,
          }
        ),
        {
          'data': this.meals.filter(mealRow => (
            mealRow.uid.includes(args.uid.replace('f_', 'c_')) || args.uid === mealRow.uid
          ) && mealRow.finalMealId === args.finalMealId),
          'date': this.date,
          'productionDate': DateHelper.format(args.productionDate),
          'hour': args.hour,
          'nullify': true,
          'type': args.type,
          'unfoldingTeamId': args.unfoldingTeamId,
        }).then(() => {
        toastr.success(
          window.Translator.trans('assign_team.flash.assigned'),
          null,
          { timeOut: 5000 }
        )
      }, response => {
        this.handleAjaxError(response)
      })
    },
    assignTeamToChecked() {
      if (this.$refs.assignTeamMealRow) {
        this.$refs.assignTeamMealRow.forEach((component) => {
          if (component.isChecked) {
            component.teamId = this.formTeam
          }
        })
      }

      this.checkedMeals.length && this.assignTeam('team', this.checkedMeals, null, this.formTeam)

    },
    assignUnfoldingTeamToChecked() {
      if (this.$refs.assignTeamMealRow) {
        this.$refs.assignTeamMealRow.forEach((component) => {
          if (component.isChecked) {
            component.unfoldingTeamId = this.formUnfoldingTeam
          }
        })
      }

      this.checkedMeals.length && this.assignTeam('unfolding_team', this.checkedMeals, null, null, this.formUnfoldingTeam)
    },
    assignDateToChecked() {
      this.checkedMeals.length && this.assignTeam('production_date', this.checkedMeals, this.formDate)
    },
    assignTeam(type, meals, productionDate, teamId, unfoldingTeamId) {
      this.requestAssignTeamDone = false
      this.$emit('disable', true)

      let data = []
      meals.forEach(function(checkedMeal) {
        this.meals.forEach((mealRow) => {
          if (
            (mealRow.uid.includes(`_${checkedMeal.mealId}_`) || mealRow.mealId === checkedMeal.mealId)
              && mealRow.finalMealId === checkedMeal.finalMealId
          ) {
            data.push(mealRow)
          }
        }, this)
      }, this)

      axios.post(Routing.generate(
        'api_post_assign_team_new',
        {
          id: teamId || 0,
          _type: type,
        }
      ), {
        'data': data,
        'date': this.date,
        'productionDate': DateHelper.format(productionDate),
        'nullify': false,
        'unfoldingTeamId' : unfoldingTeamId,
      }).then(() => {
        toastr.success(
          window.Translator.trans('assign_team.flash.assigned'),
          null,
          { timeOut: 5000 }
        )
        this.getAssignedMeals()
        this.checkedRows = []
      }, response => {
        this.handleAjaxError(response)
      }).finally(() => {
        this.$emit('disable')
        this.isCheckedAll = false
      })
    },
    getTeams() {
      this.$emit('request')
      const url = Routing.generate('api_get_active_production_teams', {
        context: 'dropdown',
        date: this.date
      })

      axios.get(url).then(response => {
        this.teams = response.data
      }, response => {
        this.handleAjaxError(response)
      }).finally(() => {
        this.requestTeamDone = true
        this.$emit('response')
      })
    },
    getUnfoldingTeams() {
      this.$emit('request')
      const url = Routing.generate('api_get_active_unfolding_teams', {
        context: 'team_simple',
        date: this.date
      })

      axios.get(url).then(response => {
        this.unfoldingTeams = response.data
      }, response => {
        this.handleAjaxError(response)
      }).finally(() => {
        this.requestUnfoldingTeamDone = true
        this.$emit('response')
      })
    },
    getAssignedMeals(loading = false) {
      this.assignedMeals = new Map()
      this.$emit(loading ? 'request' : 'disable', true)
      const url = Routing.generate('api_get_assign_team_for_date', { date: this.date })

      axios.get(url).then(response => {
        let that = this
        response.data.forEach((row) => {
          that.assignedMeals.set(row.uid, row)
        })
      }, response => {
        this.handleAjaxError(response)
      }).finally(() => {
        this.requestAssignTeamDone = true
        this.$emit(loading ? 'response' : 'disable')
      })
    },
    checkAll() {
      this.$refs.assignTeamMealRow.forEach((component) => {
        component.$refs.checkboxMeal.click()
      })
    },
  }
}
</script>

<style scoped>
form {
  margin-bottom: 15px;
}

label.mt-checkbox {
  margin-left: 15px;
}

label.mt-checkbox .checkbox-text {
  margin: 0;
  font-weight: bold;
}
</style>
